<template>
	<div>
		<vs-popup class="holamundo" :title="$t('StockTaking')" :active.sync="isSidebarActiveLocal"
			@close="closeStockTakingPopup" @cancel="closeStockTakingPopup">
			<b-row>
				<b-col>
					<vs-card>
						<b-row v-if="ROLE != 'Company'">
							<b-col cols="4" align-self="center">
								<b-form-group :label="'* ' + $t('Customer')" label-for="h-first-name"
									style="font-weight: bold; font-size: larger">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name"
									v-if="data.length > 0" disabled autocomplete ref="selectElement" name="customer"
									v-validate="'required'">
								</v-select>
								<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name"
									@input="getCustomerDepoList" v-else autocomplete ref="selectElement" name="customer"
									v-validate="'required'">
								</v-select>
								<span class="text-danger text-sm" v-show="errors.has('customer')">{{
									errors.first("customer")
								}}</span>
							</b-col>
						</b-row>
						<b-row class="mb-2 mt-3">
							<b-col cols="4" align-self="center">
								<b-form-group :label="'* ' + $t('Storehouse') + ': '" class="vs-input--label pr-0 mr-0"
									label-for="h-first-name" style="font-weight: bold; font-size: larger">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<v-select color="danger" v-model="storehouse" :options="storehouse_choices" size="small" label="name"
									autocomplete ref="selectElement" name="storehouse" v-validate="'required'">
								</v-select>

								<span class="text-danger text-sm" v-show="errors.has('storehouse')">{{
									errors.first("storehouse")
								}}</span>
							</b-col>
						</b-row>
						<b-row style="margin-top: 8px">
							<b-col cols="4" align-self="center">

								<b-form-group :label="$t('Description') + ': '" class="vs-input--label pr-0 mr-0"
									label-for="h-first-name" style="font-weight: bold; font-size: larger">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<vs-textarea v-model="description" />
							</b-col>
						</b-row>
					</vs-card>
				</b-col>
			</b-row>
			<div class="items-center pl-6 mt-0 mb-0">
				<b-row align-h="end">
					<b-col cols="3" md="auto" style="padding: 0px">
						<b-button class="bg-danger" style="border-color: white" v-on:click="closeStockTakingPopup">
							<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
								$t("Cancel") }}
						</b-button>
					</b-col>
					<b-col cols="3" md="auto">
						<b-button class="bg-primary" style="border-color: white" v-on:click="submitData()">
							<Icon icon="material-symbols:save-outline" style="margin-right: 5px" width="20" height="20" />{{
								$t("Save") }}
						</b-button>
					</b-col>
				</b-row>
			</div>
		</vs-popup>
	</div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";
import userJson from "../../../public/user.json";

export default {
	components: { Icon, vSelect, AgGridVue },
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true,
		},
		data: {
			default: () => { },
		},
	},
	data() {
		return {
			description: "",
			customer: "",
			ROLE: this.$store.state.AppActiveUser.ROLE,
			customer_choices: [],
			storehouse_choices: [],
			storehouse: "",

			stockTakingCode: "",
			stockTakingName: "",
			stockTakingFloor: 1,
			stockTakingShelf: 1,
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true,
			},
			stockActColumns: [],
			stockAct: [],
		};
	},
	methods: {
		getCustomerDepoList() {
			const vs = this.$vs;
			this.storehouse_choices = [];
			if (userJson.type == "fullfilment")
				this.$store
					.dispatch("storehouse/listStorehouseAllValues2", this.customer.CompanyId)
					.then((response) => {
						// let costumerList = JSON.parse(response.json);
						if (response.success == true) {
							this.storehouseForCustomerList = JSON.parse(response.json);
							this.storehouseForCustomerList.forEach((val, index) => {
								this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
							});
						} else console.log(response.statusText);
					});
			else {
				let depotMethods = "listStorehouseForCompany"

				if (userJson.type == "dropshipping") depotMethods = "listStorehouseAllValues2Ds"
				this.$store
					.dispatch("storehouse/" + depotMethods, this.customer.CompanyId)
					.then((response) => {
						if (response.success == true) {
							this.storehouseForCustomerList = JSON.parse(response.json);
							this.storehouseForCustomerList.forEach((val, index) => {
								this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
							});
						} else console.log(response.statusText);
					});
			}
		},
		submitData() {
			var createdId = uuid.v4();
			const vs = this.$vs;
			let method = "addStockTaking";
			this.$validator.validateAll().then((result) => {
				if (result) {
					let obj = {
						"type": 1,
						"depotId": this.storehouse.value,
						"companyId": this.customer.value,
						"description": this.description
					};

					this.$store
						.dispatch("stock/" + method, obj)
						.then((response) => {
							try {
								if (response.success == true) {
									vs.notify({
										text: response.message,
										iconPack: "feather",
										icon: "icon-alert-circle",
										color: "success",
										position: "top-center",
									});
									this.closeStockTakingPopup();
								} else {
									vs.notify({
										text: response.message.toString(),
										iconPack: "feather",
										icon: "icon-alert-circle",
										color: "danger",
										position: "top-center",
									});
								}
							} catch (error) {
								console.log(error);
							}
						})
						.catch((error) => {
							return new Promise((resolve, reject) => {
								resolve(false);
							});
						});
				} else {
					vs.notify({
						text: this.$t("Validate"),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center",
					});
				}
			});
		},
		closeStockTakingPopup() {
			this.customer = "";
			this.storehouse = "";

			this.isSidebarActiveLocal = false;
		},
		getCustomerList(id, popup) {
			this.customerListOption = [];
			this.customer_choices = [];
			this.customerListOption = this.companydata;
			this.customerListOption.forEach((val, index) => {
				this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
			});
		},
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
		},
	},
	watch: {
		companydata(val) {
			this.getCustomerList();
			return val;
		},
		data(val) {
			return val;
		},
		isSidebarActive(val) {
			if (val == true) {
				if (this.ROLE != "Company") this.getCustomerList();
				const dict = {
					custom: {
						customer: {
							required: this.$t("customerNameRequired"),
							alpha: this.$t("customerNameRequired"),
						},
						stockTakingName: {
							required: this.$t("stockTakingNameRequired"),
							alpha: this.$t("stockTakingNameRequired"),
						},
						stockTakingCode: {
							required: this.$t("stockTakingCodeRequired"),
							alpha: this.$t("stockTakingCodeRequired"),
						},
						stockTakingFloor: {
							required: this.$t("stockTakingFloorRequired"),
							alpha: this.$t("stockTakingFloorRequired"),
							min_value: this.$t("stockTakingFloorMinValue"),
						},

						stockTakingShelf: {
							required: this.$t("stockTakingShelfRequired"),
							alpha: this.$t("stockTakingShelfRequired"),
						},
						brand: {
							required: this.$t("brandRequired"),
							alpha: this.$t("brandRequired"),
						},
					},
				};
				Validator.localize("en", dict);
			}
			return val;
		},
	},
	computed: {
		companydata: {
			get() {
				return this.$store.state.customer.Customer;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		localeText() {
			return i18nData[this.$i18n.locale];
		},
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
					// this.$validator.reset()
					// this.initValues()
				}
			},
		},
	},
};
</script>
